import React from 'react';
import { useSelector } from 'react-redux';
import { getPlayerListState } from '../store/selectors/playerListSelector';
import PlayerList from '../PlayerList';

const PlayerListDataContainer = (props) => {
    const playerListState = useSelector(getPlayerListState);

    return (
        <PlayerList { ...playerListState } { ...props } />
    );
};

export default PlayerListDataContainer;
